import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import { MonthlyDeliverabilityMetrics } from "@redotech/redo-marketing-common/deliverability";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getMonthlyDeliverabilityMetrics = {
  name: "getMonthlyDeliverabilityMetrics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    channels: z.array(createEnum(MarketingChannel)).optional(),
  }),
  output: z.object({ monthlyMetrics: z.array(MonthlyDeliverabilityMetrics) }),
};
